var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandingLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 40,
    viewBox: "0 0 168 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3147 31.7109L18.6553 39.6244L27.9598 39.6029L23.3147 31.7109Z",
    fill: "#0089CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9961 15.8555L0 39.6102H9.3188L18.6555 23.7689L13.9961 15.8555Z",
    fill: "#0089CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9707 23.851L37.3682 39.7459H46.6405L32.6051 15.9805L27.9707 23.851Z",
    fill: "#FF0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9598 7.88843L23.3147 0L18.6553 7.90989L23.3004 15.8019L27.9598 7.88843Z",
    fill: "#FF0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4534 16.9606C75.0402 16.9606 77.8473 19.5424 77.8473 23.8835C77.8473 27.2842 75.3478 29.7444 71.7182 30.2415L78.516 39.6211H73.4168L66.88 30.7457H57.7329V39.6211H53.7314V16.957H68.457L68.4534 16.9606ZM57.7293 20.9549V26.8122H69.0256C71.3606 26.8122 73.8423 26.6227 73.8423 23.8835C73.8423 21.1444 70.6598 20.9549 68.9433 20.9549H57.7257H57.7293Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M136.038 39.9999L117.883 25.2172L116.925 24.4305V39.6245H112.923V16.585H112.966L131.121 31.3677L132.079 32.1544V16.9604H136.081V39.9999H136.038Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M162.525 39.6243H167.259L153.417 16.1021H153.335L139.492 39.6243H144.227L146.598 35.5299H160.118L162.525 39.6243ZM153.374 23.6865C155.316 26.8154 156.149 28.2923 158.105 31.6215H148.604C150.645 28.16 151.418 26.8154 153.374 23.6865Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1041 35.6266V30.1341H104.645V26.2256H89.1041V20.9583H106.422V16.9604H85.0991V39.6245H107.048V35.6266H89.1041Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingLogo);
export default __webpack_public_path__ + "static/media/landingLogo.02be3c797ac4b61271ac2373d51e48a5.svg";
export { ForwardRef as ReactComponent };